<template>
    <div class="ms-style-switcher">
        Style switcher
    </div>
</template>

<script>

// <link rel="stylesheet"           href="main.css">
// <link id="ms-fonts"  href="light.css" id="light-styles" title="Light">
// <link rel="stylesheet alternate" href="dark.css"  id="dark-styles"  title="Dark">

function enableCss() {
    document.getElementById('dark-styles').disabled  = false;
    document.getElementById('light-styles').disabled = true;
}

function changeCSS(cssFile, cssLinkIndex) {

    var oldlink = document.getElementsByTagName("link").item(cssLinkIndex);

    var newlink = document.createElement("link");
    newlink.setAttribute("rel", "stylesheet");
    newlink.setAttribute("type", "text/css");
    newlink.setAttribute("href", cssFile);

    document.getElementsByTagName("head").item(0).replaceChild(newlink, oldlink);
}

export default {
    
}
</script>



// WEBPACK FOOTER //
// src/components/CssSwitcher.vue